export class Assistant {
    protected messages = [];
    protected toolCalls = [];
    protected toolResults = [];

    requiredAnotherChat = false;

    constructor() {
    }

    getApiUrl(): string {
        return null;
    }

    getGenerateImageUrl(): string {
        return null;
    }

    getEditImageUrl(): string {
        return null;
    }

    addSystemMessage(message) {

    }

    addUserMessage(message) {
    }

    addToolCall(functionId, functionName, functionArgs, functionResult) {
    }


    getFunctionCalls(): any {
        return null;
    }

    getFunctionList(result) {
        return null;
    }

    getPrompt() {

    }

}
